import { create } from 'zustand';
import {
  addLocallyReadNotificationId,
  getLocallyReadNotificationIds,
} from '@/utils/localNotificationReads';

interface NotificationReadState {
  locallyReadIds: number[];
  markLocallyRead: (id: number) => void;
}

export const useNotificationReadStore = create<NotificationReadState>(
  (set) => ({
    locallyReadIds: getLocallyReadNotificationIds(),
    markLocallyRead: (id: number) => {
      addLocallyReadNotificationId(id);
      set({ locallyReadIds: getLocallyReadNotificationIds() });
    },
  })
);
